import { makeStyles } from "@material-ui/core";
import { TopToolbar } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    justifyContent: "space-between",
    "& > button": {
      padding: "10px",
    },
  },
}));

export function Actions(props) {
  const classes = useStyles();

  return <TopToolbar className={classes.root} {...props} />;
}
